import { render, staticRenderFns } from "./QualityAssuranceQuestionnaireSubmissions.vue?vue&type=template&id=6070ad2e&"
import script from "./QualityAssuranceQuestionnaireSubmissions.vue?vue&type=script&lang=js&"
export * from "./QualityAssuranceQuestionnaireSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports